import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ToolbarButton } from '@ohif/ui';
import { AZModal } from '@azmed-org/azcomponents';

import { useResetToolbarButton } from './useResetToolbarButton';
import './ResetToolbarButton.css';

// Reset toolbar button, asking whether the current image's annotations must go too.
function ResetToolbarButton({ toolbarClickCallback, button, isActive }) {
  const [t] = useTranslation('Buttons');
  const {
    plan,
    declineRef,
    requestReset,
    confirmDelete,
    declineDelete,
    cancel,
  } = useResetToolbarButton({ button, toolbarClickCallback });

  return (
    <React.Fragment>
      <ToolbarButton
        label={button.label}
        icon={button.icon}
        onClick={requestReset}
        isActive={isActive}
      />
      <AZModal
        show={Boolean(plan)}
        onClose={cancel}
        bigTitle={t('Annotations')}
        fullscreen={false}
        maxWidth="480px"
      >
        <div className="ResetToolbarButton-Container">
          <p className="ResetToolbarButton-Message">
            {t('Delete the annotations on this image too?')}
          </p>
          <div className="ResetToolbarButton-Actions">
            <button
              type="button"
              ref={declineRef}
              className="ResetToolbarButton-Action"
              onClick={declineDelete}
            >
              {t('No')}
            </button>
            <button
              type="button"
              className="ResetToolbarButton-Action"
              onClick={confirmDelete}
            >
              {t('Yes')}
            </button>
          </div>
        </div>
      </AZModal>
    </React.Fragment>
  );
}

ResetToolbarButton.propTypes = {
  parentContext: PropTypes.object,
  toolbarClickCallback: PropTypes.func.isRequired,
  button: PropTypes.object.isRequired,
  activeButtons: PropTypes.array,
  isActive: PropTypes.bool,
};

export { ResetToolbarButton };
